module.exports = "/img/25.8801b8.webp";